import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { get } from '../../helper/helper_api';
import Loader from '../../Loader';

export default function ArtistList() {
    const [artists, setArtists] = useState([]);
    const [loader, setLoader] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        window.scroll(0, 0);
        fetchArtists();
    }, [])

    const fetchArtists = () => {
        setLoader(true)
        get('/artist/list').then((json) => {
            setLoader(false);
            if (json?.statusCode == 200) {
                // Filter only active artists
                const activeArtists = json?.data?.filter(item => item?.isActive);
                setArtists(activeArtists);
            }
        }).catch((err) => {
            console.log(err);
            setLoader(false)
        });
    }

    const openArtist = (item) => {
        const tempId = item?._id.slice(item?._id.length - 4, item?._id.length);
        navigate('/artist/' + tempId + "/" + (item?.name).split(" ").join("-").toLowerCase());
    }

    return (
        <>
            {
                loader && <Loader />
            }
            <div id="tg-wrapper" className="tg-wrapper tg-haslayout">

                {/* <section className="tg-parallax tg-innerbanner tg_innerbanner">
                    <div className="tg-sectionspace tg-haslayout inner_banner yoga_ayurveda" style={{ backgroundImage: `url(${require('../../assets2/images/about-us-banner_3.jpg')})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'center' }}>
                        <div className="container">
                            <div className="row">
                                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                    <h1>Artists</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </section> */}

                <main id="tg-main" className="tg-main tg-haslayout container____">

                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">Artists</li>
                        </ol>
                    </nav>
                    <section className='tg-innerbanner heading_section' id="AtAGlance">
                        <h1>Textile Artists</h1>
                    </section>
                    <section className="tour_sec pt-30px">
                        <div className="container Testimonials_section Testimonials_section_detination" style={{ position: 'relative' }}>
                            <div className="row">
                                {artists?.length > 0 ? (
                                    artists.map((item, index) => (
                                        <div className="col-lg-4 col-md-6 col-sm-12" key={index} style={{ marginBottom: '30px' }}>
                                            <figure className="snip1208" style={{ cursor: 'pointer' }} onClick={() => openArtist(item)}>
                                                <div style={{ height: '300px', overflow: 'hidden' }}>
                                                    <img src={item?.image} alt={item?.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                                </div>
                                                <figcaption style={{ padding: '20px', minHeight: '140px' }}>
                                                    <h3 style={{ fontSize: '20px', fontWeight: 'bold', marginBottom: '5px' }}>{item?.name}</h3>
                                                    <p className="occupation" style={{ color: '#ec048a', fontWeight: '500', marginBottom: '5px', textTransform: 'uppercase', fontSize: '13px', letterSpacing: '1px' }}>
                                                        {item?.occupation}
                                                    </p>
                                                    <p className="country" style={{ color: '#555555', fontSize: '14px', margin: '0' }}>
                                                        <span className="fa fa-map-marker" style={{ marginRight: '5px', color: '#ec048a' }}></span>
                                                        {item?.countryName || item?.country || "India"}
                                                    </p>
                                                </figcaption>
                                            </figure>
                                        </div>
                                    ))
                                ) : (
                                    <div className="col-xs-12 text-center" style={{ padding: '80px 0' }}>
                                        <h3>No artists found</h3>
                                    </div>
                                )}
                            </div>
                        </div>
                    </section>

                </main>

            </div>
        </>
    )
}
